var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43248 8.92423L5.07498 11.5667C6.15998 12.6517 7.92164 12.6517 9.01248 11.5667L11.5733 9.0059C12.6583 7.9209 12.6583 6.15923 11.5733 5.0684L8.92498 2.43174C8.37081 1.87757 7.60664 1.58007 6.82498 1.6209L3.90831 1.7609C2.74164 1.8134 1.81414 2.7409 1.75581 3.90174L1.61581 6.8184C1.58081 7.6059 1.87831 8.37007 2.43248 8.92423Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54159 7.00065C6.347 7.00065 6.99992 6.34773 6.99992 5.54232C6.99992 4.7369 6.347 4.08398 5.54159 4.08398C4.73617 4.08398 4.08325 4.7369 4.08325 5.54232C4.08325 6.34773 4.73617 7.00065 5.54159 7.00065Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceLabel);
export default __webpack_public_path__ + "static/media/device-label.5cf6aa5ad3d6809d9bb66b189ec4628b.svg";
export { ForwardRef as ReactComponent };